import React from 'react';
import { useTranslation } from 'react-i18next';
import { IonList } from '@ionic/react';
import { PaymentMethod } from '../../services/types/apitypes';
import './PaymentsList.css';
import PaymentItem from './PaymentItem';

export const AdditionalPaymentMethods = ["GOOGLE", "APPLE"] as const;
export type AdditionalPaymentMethod = (typeof AdditionalPaymentMethods)[number]

type PaymentsListProps = {
  payments: PaymentMethod[];

  additionalPayments: AdditionalPaymentMethod[];
  selectPayment: (p: PaymentMethod | AdditionalPaymentMethod) => void;
};

export default function PaymentsList({
  payments,
  additionalPayments,
  selectPayment,
}: PaymentsListProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <p className="pt-2 pb-2 instructions ion-text-center">
        {t('payments.info')}
      </p>
        <h1 className="h1">Cards</h1>
      <IonList>
        {payments.map((item: PaymentMethod, i: number) => (
          <PaymentItem key={i} click={selectPayment} payment={item} />
        ))}
      </IonList>
        {additionalPayments.length > 0 && <>
            <h1  className="h1">Other</h1>

            <IonList>
                {additionalPayments.map((item, i: number) => (
                    <PaymentItem key={i} click={selectPayment} otherPaymentType={item} />
                ))}
            </IonList>
        </>}
    </>
  );
}
